import React from 'react';
import Image from 'react-bootstrap/Image';
import CoutDown from '../components/CoutDown';
import Carousel from 'react-bootstrap/Carousel';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/css/Banner.css';
import '../assets/css/Carousel-custom.css';
const Announce_banner = () => {
    return (
        <>
            <section className="wedding_banner" id='home'>
                <div className="wedding_announcement">
                    <h2 className="loader wow fadeInLeft" data-wow-delay="0.2s" data-wow-duration="1.2s">
                        <span>W</span>
                        <span>e</span>
                        <span>d</span>
                        <span>d</span>
                        <span>i</span>
                        <span>n</span>
                        <span>g</span>
                        <span></span>
                        <span>D</span>
                        <span>a</span>
                        <span>y</span>
                    </h2>
                    <p className="wow fadeInRight" data-wow-delay="0.2s" data-wow-duration="1.2s"><span>17 Mai 2024</span></p>
                    <div className="wpo-wedding-date">
                        <div className="clock-grids">
                            <div id="clock" className="d-flex">
                                <CoutDown date={'May 17 24 16:00:00'} />
                            </div>
                        </div>
                    </div>
                </div>
                <Carousel fade indicators={false} interval={3500} >
                    <Carousel.Item>
                        <Image
                            className="img-fluid"
                            alt="First slide"
                            width="100%"
                            src={require('../assets/images/slider/slide-1.jpg')}
                        />
                    </Carousel.Item>
                    <Carousel.Item>
                        <Image
                            className="img-fluid"
                            alt="Second slide"
                            width="100%"
                            src={require('../assets/images/slider/slide-2.jpg')}
                        />
                    </Carousel.Item>
                    <Carousel.Item>
                        <Image
                            className="img-fluid"
                            alt="First slide"
                            width="100%"
                            src={require('../assets/images/slider/slide-6.jpg')}
                        />
                    </Carousel.Item>
                </Carousel>
            </section>
        </>
    )
}
export default Announce_banner;